// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-259zm","header":"header-35WkM","icon":"icon-Tfdp2"};